"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVersion = exports.getDeviceId = exports.isHttpUrl = void 0;
const uuid_1 = require("uuid");
const HTTP_REGEX = "^https?:";
function getUrlProtocol(url) {
    const matches = url.match(new RegExp(/^\w+:/, "gi"));
    if (!matches || !matches.length)
        return;
    return matches[0];
}
function matchRegexProtocol(url, regex) {
    const protocol = getUrlProtocol(url);
    if (typeof protocol === "undefined")
        return false;
    return new RegExp(regex).test(protocol);
}
function isHttpUrl(url) {
    return matchRegexProtocol(url, HTTP_REGEX);
}
exports.isHttpUrl = isHttpUrl;
function getDeviceId() {
    const storeKey = "pn_device_id";
    let deviceId = window.localStorage.getItem(storeKey);
    if (!deviceId) {
        deviceId = (0, uuid_1.v4)();
        window.localStorage.setItem(storeKey, deviceId);
    }
    return deviceId;
}
exports.getDeviceId = getDeviceId;
function getVersion() {
    return "web_0.4.0";
}
exports.getVersion = getVersion;
//# sourceMappingURL=utils.js.map